let g_dev = false;

// window vars
let g_windowHeight = $(window).height();
let g_windowWidth = $(window).width();

$(window).resize(function () {
    g_windowHeight = $(window).height();
    g_windowWidth = $(window).width();
});

// scroll vars
let g_scroll = $(window).scrollTop();
$(window).scroll(function () {
    g_scroll = $(window).scrollTop();

    scrolltopLink();
});

// scrolltoplink
function scrolltopLink() {
    if(g_scroll > (g_windowHeight*0.5)) {
        $('body').find('.scroll-top-link').addClass('active');
    } else {
        $('body').find('.scroll-top-link').removeClass('active');
    }
}

// loadJs
function loadJs(filename) {
    let l = document.createElement('script');
    l.type = 'text/javascript';
    l.src = filename;
    let h = document.getElementsByTagName('head')[0];
    h.parentNode.insertBefore(l, h);
}


// Unsorted scripts
$(document).ready(function () {

    $('[data-vbg]').youtube_background();

    setFixedHeader();
    $(window).on('load', function() {
        setFixedHeader();
    })
    $(window).on('scroll', function() {
        setFixedHeader();
    })
    $(document.body).on('touchmove', function() {
        setFixedHeader();
    })

    // Print page
    $('[data-print]').on('click', function() {
        window.print();
        lazySizes.loader.unveil('.lazyload');
    })

    // test
    jsToggle();

    wysiwyg_toggle();

    $('[data-toggle-target=".bigmenu-parent"]').on('click', function() {
        $('.bigmenu-parent').find('img[data-src-placeholder]').each(function(){
            var imageSrc = $(this).data('src-placeholder');
            $(this).attr('src', imageSrc);
            console.log('image: '+$(this).data('src-placeholder'))
        })
    })

    // masonry
    if($('.masonry-wrapper').length>0) {
        $('.masonry-wrapper').masonry({
            itemSelector: '.masonry-item'
        });
    }

    // tooltipster
    if($('.tooltip').length>0) {
        $('.tooltip').tooltipster({
            theme: 'tooltipster-light'
        });
    }

    // pre-toggle
    $('pre').each(function () {
        $(this).prepend('<div class="pre-toggle"><i class="icon icon-chevron-down"></i></div>');
    });
    $('.pre-toggle').on('click', function () {
        $(this).closest('pre').toggleClass('active');
    });

    // dismiss alert
    $(".alert .icon-cross").on('click', function (e) {
        e.preventDefault();
        $(this).closest(".alert").remove();
    });

    // social media share buttons
    $('.share').on('click', function (e) {
        e.preventDefault();
        let target = $(this).attr('href').toString();
        window.open(target, 'popup', 'width=500, height=300, top=20, left=20');
    });

    if ($('#action-popup').length > 0) {
        if (!localStorage['action-popup-shown']) {
            if (typeof $.fancybox === 'function') {
                localStorage['action-popup-shown'] = true;
                $.fancybox.open([
                    {
                        href: '#action-popup'
                    }
                ]);
            }
        }
    }

    // newsletter sign-up form
    $('#newsletter-form').on('submit', function (e) {
        e.preventDefault();

        let name = $('input[name="name"]', $(this)).val();
        let mail = $('input[name="mail"]', $(this)).val();

        $('.formElement').removeClass('error');
        $('#newsletter-form').parent().find(".alert").remove();

        $.ajax({
            type: 'POST',
            url: 'ajax/mailchimp',
            data: {name: name, mail: mail}
        }).done(function (feedback) {
            let alertClass;
            if (feedback.hasOwnProperty('error') && feedback.error === 1) {
                $('.formElement').addClass('warning');
                alertClass = 'error';
            } else {
                $('#newsletter-form').hide();
                alertClass = 'success';
            }
            $('#newsletter-form').parent().prepend('<div class="alert alert-' + alertClass + '"><p>' + feedback.message + '</p></div>');
        });
    });

    // toggle footer sections
    footerToggles();

    // check password
    $('#password').keyup(function () {
        $('#progress-bar .progress').html(checkStrength($(this).val()));
    });

    // product placement
    productPlacement();

    // deprecated??
    $('.filter-toggle').on('click', function() {
        $(this).parent().toggleClass('inactive');
    });

    productSlider();

    // autohide flash message in footer
    if ($(".flash-message .wrapper .alert").length) {
        $(".flash-message .wrapper .alert").append('<p class="autohide-message text-sm">autoclose</p>');
        $("body").append('<span id="countdown" style="display:none;">10</span>');
        countdown();
    }

    headerSiteWrapper();

    smallerNav();

    equalElements();

    $('.flatpickr-toggle').flatpickr({
        dateFormat: 'd-m-Y',
        locale: 'nl',
        allowInput: true,
        disableMobile: true,
        wrap: true,
        clickOpens: false
    });

    // Jquery mask inputs
    $('.mask-date').mask('00-00-0000');

    // Contactbox
    contactBox();

});

$(window).on('load', function() {

    // reset slide height
    $('.slide-caption').each(function(){
        $(this).height('');
    });

    headerSiteWrapper();

});

$(window).resize(function() {

    // product slider
    if($('.slider-productimages-navigation:not(.slick-initialized)').length > 0) {
        productSlider();
    }

    // toggle footer sections
    wysiwyg_toggle();

    // check password
    footerToggles();

    // product detail readmore toggle
    readmoreToggle();

    // product placement
    productPlacement();

    // untoggle (Klantenservice menu)
    unToggle();

    headerSiteWrapper();

    smallerNav();

});

$('html').on( 'DOMMouseScroll mousewheel', function ( event ) {
    if( event.originalEvent.detail > 0 || event.originalEvent.wheelDelta < 0 ) { //alternative options for wheelData: wheelDeltaX & wheelDeltaY
        $('body').addClass('body_scroll-down');
        $('body').removeClass('body_scroll-up');
    } else {
        $('body').addClass('body_scroll-up');
        $('body').removeClass('body_scroll-down');
    }
});

let start = null;
window.addEventListener('touchstart', function(e) {
    start = e.changedTouches[0];
});

window.addEventListener('touchend', function(e) {
    let end = e.changedTouches[0];

    if(end.screenY - start.screenY > 0) {
        $('body').addClass('body_scroll-up');
        $('body').removeClass('body_scroll-down');
    } else if(end.screenY - start.screenY < 0) {
        $('body').addClass('body_scroll-down');
        $('body').removeClass('body_scroll-up');
    }
});

// var lastPoint = null; //global
// $(window).on('touchmove', function(e){
//     console.log('1');
//     var currentPoint = e.originalEvent.changedTouches[0].pageY;
//     if (lastPoint != null && lastPoint < currentPoint ){
//         $('body').addClass('body_scroll-down');
//         $('body').removeClass('body_scroll-up');
//     } else if(lastPoint != null && lastPoint > currentPoint){
//         $('body').addClass('body_scroll-up');
//         $('body').removeClass('body_scroll-down');
//     }
//     lastPoint = currentPoint;
// });


function setFixedHeader() {
    var topbarHeight = $('.topbar-section').outerHeight();
    var headerHeight = $('.header-section').outerHeight();

    if(topbarHeight!=undefined || headerHeight!=undefined) {
        $('.site-wrapper').css('padding-top', (topbarHeight+headerHeight));
    }

    // Topbar
    if(g_scroll >= topbarHeight) {
        $('.topbar-section').addClass('fixed-scroll');
    } else {
        $('.topbar-section').removeClass('fixed-scroll');
    }

    // Header
    if(g_scroll >= topbarHeight) {
        $('.header-section').addClass('fixed-scroll');
    } else {
        $('.header-section').removeClass('fixed-scroll');
    }

    if(g_scroll >= 2) {
        $('.highlight-logo').addClass('scroll');
    } else {
        $('.highlight-logo').removeClass('scroll');
    }
}


// check header-height
function headerSiteWrapper() {
    if(!$('body').hasClass('body_link-tree')) {
        if ($('body').hasClass('body_mobile-menu')) {
            var headerHeight = Math.ceil($('body').find('.header-section').height() - 1);

            $('.site-wrapper').css('padding-top', headerHeight);
        } else {
            $('.site-wrapper').css('padding-top', '');
        }
    }
}


// data equal
function equalElements() {
    var equalGroups = {};

    // generate groups by their groupId set by elements using equal-group
    $('[data-equal-element]').each(function() {
        var $this = $(this),
            groupId = $this.attr('data-equal-element');
        if (groupId in equalGroups) {
            equalGroups[groupId] = equalGroups[groupId].add($this);
        } else {
            equalGroups[groupId] = $this;
        }
    });

    // apply minHeight to each group
    $.each(equalGroups, function() {
        elementHeight = $('[data-equal-type="measure"]').outerHeight();

        if(elementHeight > 500) {
            $('[data-equal-element]').each(function() {
                if($(this).outerHeight() > elementHeight) {
                    $(this).height(elementHeight);
                    $(this).addClass('active');
                } else {
                    $(this).css('height','');
                    $(this).removeClass('active');
                }
            });
        }
    });
}


// check password strength
function checkStrength(password) {
    let strength = 0;
    let progress = (6.25 * password.length);
    progress = (progress > 100 ? 100 : progress) + '%';

    if (password.length === 0) {
        strength = 0;
    }
    if (password.length >= 1) {
        strength = 1;
    }
    if (password.length >= 8) {
        strength += 1;
    }
    if (password.length >= 12) {
        strength += 1;
    }
    if (password.length >= 16) {
        strength += 1;
    }

    $('.progress').removeClass('progress-error progress-warning progress-info progress-success');
    $('.progress').css('width', progress);

    if (strength === 0) {
        $('.progress').removeClass('progress-error progress-warning progress-info progress-success');
        return '';
    } else if (strength === 1) {
        $('.progress').addClass('progress-error');
        return '<span>Te kort</span>';
    } else if (strength === 2) {
        $('.progress').addClass('progress-warning');
        return '<span>Zwak</span>';
    } else if (strength === 3) {
        $('.progress').addClass('progress-info');
        return '<span>Goed</span>';
    } else {
        $('.progress').addClass('progress-success');
        return '<span>Sterk</span>';
    }
}


// toggle footer sections
function footerToggles() {
    if (g_windowWidth < 640) {
        $('.footer-section .toggle-parent').attr('data-toggle','parent toggle-js');
        $('.footer-section .toggle-title').attr('data-toggle','title');
        $('.footer-section .toggle-text').attr('data-toggle','text');
    } else {
        $('.footer-section .toggle-parent').removeAttr('data-toggle');
        $('.footer-section .toggle-title').removeAttr('data-toggle');
        $('.footer-section .toggle-text').removeAttr('data-toggle');
    }
}

$('body').on('click', '.js-filter-toggle', function() {
    filterToggle($(this));
});


// filterToggle
function filterToggle(filterBtn) {
    $('body').find('.filters').toggleClass('active');
    if($('.filters').hasClass('active')) {
        filterBtn.html('Verberg filters');
    } else {
        filterBtn.html('Toon filters');
    }
}


// productdetail placement
function productPlacement() {
    if($('.col-product-left > .product-info').length > 0) {
        if(g_windowWidth < 640) {
            $('.col-product-left > .product-info').appendTo('.col-product-right');
        } else {
            $('.col-product-right > .product-info').appendTo('.col-product-left');
        }
    } else {
        if(g_windowWidth < 640) {
            $('.col-product-left > .product-info').appendTo('.col-product-right');
        } else {
            $('.col-product-right > .product-info').appendTo('.col-product-left');
        }
    }
}


// productdetail readmore
function readmoreToggle() {
    var productleft = $('.col-product-left .product-info').height();
    var productright = $('.col-product-right').height();
    var galleryHeight = $('.product-gallery').height();

    if(g_windowWidth >= 640) {
        if(productleft > 400) {
            $('.col-product-left').addClass('read-more');
            if((galleryHeight+100) > (productright+10)) {
                $('.col-product-left').removeClass('active').css('max-height', galleryHeight+100);
            } else {
                $('.col-product-left').removeClass('active').css('max-height', productright+10);
            }
        } else {
            $('.col-product-left').removeClass('read-more');
            $('.col-product-left').addClass('active');
        }
    } else {
        $('.col-product-left').removeClass('read-more');
        $('.col-product-left').addClass('active');
    }

    $('body').on('click', '.read-more-toggle', function() {
        $(this).closest('.read-more').addClass('active');
    });
}


// toggle
function jsToggle() {
    $('.js-toggle').each(function () {
        var jsToggle = $(this).attr('data-toggle');
    });

    $('body').on('click', '.js-toggle', function(e) {
        var jsToggle = $(this).attr('data-toggle');
        $('body').find('.'+jsToggle).toggleClass('active');
    });
}

function unToggle() {
    $('body').find('.services-menu .list-menu').removeClass('active');
}

// headernav
function smallerNav() {
    var parentWidth = $('[data-menu-measure="parent"]').width();
    var childsWidth = $('[data-menu-measure="logo"]').width();

    $('[data-menu-measure="child"]').each(function() {
        childsWidth += $(this).outerWidth();
    });

    if(childsWidth >= parentWidth) {
        $('[data-menu-measure="logo"]').addClass('small');
    } else {
        $('[data-menu-measure="logo"]').removeClass('small');
    }
}




// SLICK sliders

// general slider
$(document).ready(function () {
    if ($('.usp-slider').length > 0) {
        $('.usp-slider').slick({
            dotsClass: 'slick-dots inside-dots',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            mobileFirst: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            autoplay: true,
            infinite: false,
            arrows: false,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1120,
                    settings: {
                        slidesToShow: 'unslick'
                    }
                },
                {
                    breakpoint: 959,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 2
                    }
                },
            ]
        });
    }

    if ($('.slider').length > 0) {
        $('.slider').slick({
            dotsClass: 'slick-dots inside-dots',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            autoplay: true,
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0
        });
    }

    if ($('.slider-assortment').length > 0) {
        $('.slider-assortment').slick({
            dotsClass: 'slick-dots inside-dots',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToScroll: 1,
            slidesToShow: 5,
            draggable: true,
            autoplay: true,
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 4,
                        adaptiveHeight: true
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 2,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }

    if ($('.slider-blog').length > 0) {
        $('.slider-blog').slick({
            dotsClass: 'slick-dots',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToScroll: 2,
            slidesToShow: 2,
            draggable: true,
            autoplay: true,
            infinite: false,
            arrows: false,
            dots: true,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }

    if ($('.slider-productimages').length > 0) {
        $('.slider-productimages').slick({
            asNavFor: '.slider-productimages-navigation',
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 1,
            draggable: false,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        draggable: true,
                        autoplay: true,
                        arrows: true
                    }
                }
            ]
        });
        $('.slider-productimages').on('setPosition', function(event, slick) {
            setTimeout(function(){
                readmoreToggle();
            }, 200);
        });
    }
});

function productSlider() {
    if ($('.slider-productimages-navigation').length > 0) {
        if(g_windowWidth > 640) {
            $('.slider-productimages-navigation').slick({
                asNavFor: '.slider-productimages',
                focusOnSelect: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                slidesToScroll: 1,
                centerMode: false,
                draggable: false,
                slidesToShow: 6,
                autoplay: false,
                infinite: false,
                arrows: false,
                dots: false,
                speed: 500,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: 'unslick'
                    }
                ]
            });
        } else {
            $('.slider-productimages-navigation').slick({
                asNavFor: '.slider-productimages',
                focusOnSelect: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                slidesToScroll: 1,
                centerMode: false,
                slidesToShow: 6,
                draggable: true,
                autoplay: false,
                infinite: false,
                arrows: false,
                dots: false,
                speed: 500,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: 'unslick'
                    }
                ]
            });
        }
    }
}

// media slider
$(document).ready(function () {
    if ($('.slider-media').length > 0) {
        $('.slider-media').slick({
            autoplaySpeed: 5000,
            pauseOnHover: false,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 6,
            draggable: true,
            autoplay: true,
            infinite: true,
            arrows: false,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: 'unslick'
                }
            ]
        });
    }
});


// brands slider
$(document).ready(function () {
    if ($('.slider-brands-banner').length > 0) {
        $('.slider-brands-banner').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            autoplay: true,
            infinite: true,
            autoplaySpeed: 5000,
            asNavFor: '.slider-brands'
        });
    }
});

$(document).ready(function () {
    if ($('.slider-brands').length > 0) {
        $('.slider-brands').slick({
            lazyLoad: 'ondemand',
            asNavFor: '.slider-brands-banner',
            focusOnSelect: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 6,
            draggable: true,
            autoplay: true,
            infinite: true,
            arrows: false,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
});


// fancybox
// options for different instances
$(window).on('load', function () {
    $(".fancy-gallery").fancybox({
        buttons: [
            'thumbs',
            'close'
        ],
        thumbs: {
            autoStart: true
        },
        animationEffect: "fade",
        animationDuration: 300
    });

    $(".fancy-image").fancybox({
        margin: [44, 0, 124, 0]
    });

    $(".fancy-modal").fancybox({
        modal: true
    });

    $(".fancy-iframe").fancybox({
        buttons: [
            'close'
        ],
        iframe: {
            css: {
                width: '1000px',
            }
        }
    });

    $(".fancy-bpost").fancybox({
        buttons: [
            'close'
        ],
        iframe: {
            css: {
                height: '591px',
            }
        }
    });
});


// google maps
// only for single map usage
let mapsLoader = null;
let latlong = false;
let address = '';
let scriptLocation = '';

if ($("#google_maps").length > 0) {
    address = $("#google_maps").data('address');
    scriptLocation = $("#google_maps").data('script');

    $(function () {
        tryToInitializeGmaps();
        $(window).on('resize scroll', function () {
            tryToInitializeGmaps();
        });
    });

    function tryToInitializeGmaps() {
        if ($('#google_maps_wrapper').isInViewport()) {
            if (mapsLoader === null) {
                lazyLoadGoogleMap();
            }
        }
    }

    function initializeGmaps() {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': address}, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                latlong = results[0].geometry.location;

                let mapsOptions = {
                    zoom: 12,
                    center: latlong,
                    scrollwheel: false,
                    disableDefaultUI: true,
                    panControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL,
                        position: google.maps.ControlPosition.TOP_LEFT
                    },

                    mapTypeControl: false,
                    streetViewControl: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                let map = new google.maps.Map(
                    document.getElementById("google_maps"),
                    mapsOptions
                );

                let marker = new google.maps.Marker({
                    icon: 'frontend/img/marker_anubiscare.png',
                    position: latlong,
                    map: map
                });

                // pan to the right
                if ($(".google_maps_info").css('maxWidth') !== 'none') {
                    let offset = ($(".google_maps_info").width() / 2) + 30;
                    /* 30 pixels for margin */
                    map.panBy(offset, 0);
                }

            } else {
                alert("Geocode was not successful for the following reason: " + status);
            }
        });
    }

    function lazyLoadGoogleMap() {
        mapsLoader = $.getScript(scriptLocation)
            .done(function () {
                initializeGmaps();
            })
            .fail(function (jqxhr, settings, ex) {
                alert("Could not load Google Map script");
            });
    }
}

(function(){
    let docElem = document.documentElement;
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.preloadAfterLoad = false; /** afbeelding pas laden als ze ook echt in beeld zijn **/
    window.lazySizesConfig.loadMode = 1; /** afbeelding op de rand van de viewport laden **/
    window.lazySizesConfig.expand = 100; /** geen extra pixels bij de viewport **/
})();


// countdown
var seconds;
var temp;

function countdown() {
    var seconds = $('#countdown').text();
    seconds = parseInt(seconds, 8);

    seconds--;

    if (seconds == 0) {
        $(".alert").slideUp();
        setTimeout(function(){
            $(".alert").remove();
            $('#countdown').remove();
        }, 1000);
        return;
    }

    $('#countdown').text(seconds);
    $('.autohide-message').text('sluit in '+seconds+' sec.');
    setTimeout(countdown, 1000);
}


function submitCookieForm() {
    $('#cookie-form').submit()
}


$('body').on('click', ".row-giveaway", function() {
    $(".row-giveaway").removeClass("active");
    $(this).addClass("active");
});
